const state = {
    factoryList: {},
    portList: {},
    selectedTab: null,
    tableLoadControl: {
        warehouseList: false,
        factoryList: false,
        portList: false
    },
    totalizers: null,
    portTotalizers: null,
    searchText: null,
    factoryFilter: {
        page: 0,
        size: 10
    },
    portFilter: {
        page: 0,
        size: 10,
        portId: 0
    },
    loanTotalizers: null,
    loanTotalizersModal: null,
    loanCompanyList: [],
    loansList: []
};

export default state;
